import React, { useContext } from 'react';
import { AppDataContext } from 'contexts/appData';
import { Recommendation } from './Recommendation';
import { ReactComponent as TipIcon } from '../../../../../resources/img/icons/tips_and_updates.svg';
import { ReactComponent as LockIcon } from '../../../../../resources/img/icons/lock_clock.svg';
import { useAnalyticsContext } from '../AnalyticsProvider';

export const ComingSoon = () => {
  const { langs } = useContext(AppDataContext);

  return (
    <div className="position-relative w-100" style={{ border: '1px solid #F4F4F5', borderRadius: 12, background: 'rgba(246, 246, 246, 0.3)' }}>
      <div className="d-flex flex-column justify-content-center align-items-center w-100 py-48px py-md-80px" style={{ filter: 'blur(12px)' }}>
        <div className="mb-6px">
          <TipIcon />
        </div>
        <div className="font-medium font-size-14 mb-4px" style={{ color: '#222' }}>
          არ გვაქვს რეკომენდაცია
        </div>
        <div className="font-size-12 text-center" style={{ color: '#757B8C' }}>
          ყველაფერი კარგადაა, ჯერ-ჯერობით ესე გავაგრძელოთ
        </div>
      </div>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
      >
        <div
          className="d-flex align-items-center mb-12px"
          style={{ padding: '4px 8px', color: '#fff', background: 'linear-gradient(83deg, #FF881F 1.69%, #FECB00 94.07%)', borderRadius: '99px' }}
        >
          <LockIcon style={{ marginRight: 4 }} />
          <div className="font-medium font-size-12">{langs?.NM_WillAddedSoon}</div>
        </div>
        <div className="text-center font-size-12 px-48px" style={{ color: '#222' }}>
          {langs?.NM_RecommendationsSoon}
        </div>
      </div>
    </div>
  );
};

export const Recommendations = () => {
  const { langs } = useContext(AppDataContext);
  const { recommendations } = useAnalyticsContext();

  const hasRecommendations = Array.isArray(recommendations) && recommendations.length > 0;

  return (
    <div className="bg-white w-100 max-width-lg-360px flex-shrink d-flex flex-column" style={{ border: '1px solid #EEE', borderRadius: 12 }}>
      <div className="font-bold" style={{ padding: '20px', fontSize: 16, color: '#0A0A0A', borderBottom: '1px solid #EEE' }}>
        {langs?.NM_Recommendations}
      </div>

      <div className="d-flex p-16px gap-16px flex-wrap">
        {hasRecommendations ? (
          recommendations.map((recommendation) => (
            <Recommendation key={recommendation.id} title={recommendation.title} description={recommendation.description} />
          ))
        ) : (
          <ComingSoon />
        )}
      </div>
    </div>
  );
};
